import React from 'react';
import { Link } from 'react-router';
import { observer } from 'mobx-react-lite';
import { Notification, useNovu } from '@novu/react';

import styled from 'styled-components';

import { timeDifference } from '../../lib/utils/TimeDifference';

interface NotificationItemProps {
  notification: Notification;
  onClick?: () => void;
}

export const NotificationItem = observer(
  React.forwardRef<HTMLAnchorElement, NotificationItemProps>(({ notification, onClick }, ref) => {
    console.log(notification);
    const novu = useNovu();
    const { id, createdAt, isRead, subject, body, redirect } = notification;

    const handleNotificationClick = () => {
      onClick && onClick();

      if (!isRead) {
        novu.notifications.read({ notificationId: notification.id });
      }
    };

    return (
      <Container
        data-testid={`notification-${id}`}
        ref={ref}
        onClick={handleNotificationClick}
        to={redirect?.url}
      >
        <Item data-read={isRead}>
          <p dangerouslySetInnerHTML={{ __html: subject || body }} />

          <span>{timeDifference(new Date(), createdAt)}</span>
        </Item>

        <UnreadSpot data-visible={!isRead} />
      </Container>
    );
  }),
);

const Container = styled(Link)`
  all: unset;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 1.6rem;
  cursor: pointer;

  &:hover {
    p {
      transition: all 0.2s ease;
      color: var(--color-grayscale-white, #fafafa);

      &:last-child {
        color: var(--color-grayscale-athens, #e4e6ea);
      }
    }
  }
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  min-width: 0;

  & > span {
    font-size: 1.2rem;
    font-weight: 300;
    color: var(--color-grayscale-light-slate, #7a8296);
  }

  &[data-read='false'] {
    p {
      color: var(--color-grayscale-white, #fafafa);
    }
  }

  &[data-read='true'] {
    & * {
      color: var(--color-grayscale-light-slate, #7a8296);

      &:last-child {
        color: var(--color-grayscale-light-slate, #7a8296);
      }
    }
  }
`;

const UnreadSpot = styled.span`
  width: 1rem;
  min-width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: var(--color-primary-telemagenta, #d53075);
  visibility: hidden;

  &[data-visible='true'] {
    visibility: visible;
  }
`;
